import react, { useState, useEffect } from "react";
import {Grid, Typography, Container, Button, Skeleton, Paper, Divider,
  Accordion, AccordionSummary, AccordionDetails, TableBody, TableCell,
  Table, TableRow, IconButton,
} from "@mui/material";
import SolutionList from "../components/SolutionList";
import { useHistory } from "react-router-dom";
import { ParametersLabelToDisplayText } from "../utils/constants";
import { SafeParseJSON } from "../utils/Utils";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Api from "../services/Api";
import { useUserInfoContext } from "../contexts/UserInfoContext";
import UserUtils from "../utils/userUtils";
import useDocumentTitle from "../hooks/useDocumentTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import { ReadableDateTime } from "../utils/momentUtils";
import { ConfirmDialog } from "../components/ConfirmDialog";



export const SingleOptimizationViewHOC = ({location, ...props}) => {
  const {optimization} = location.state ? location.state : {};
  return (
    <SingleOptimizationView {...props} optimization={optimization}/>
  )
}

export const SingleOptimizationView = ({optimization, ...props}) => {
  const history = useHistory();
  const {checkIfUserHasRole} = useUserInfoContext();
  const [opt, setOpt] = useState(optimization)
  const [open, setOpen] = useState(false);

  useDocumentTitle(opt.name ? `${opt.name}` : "Results");

  const onItemClick = (solution) => {
    if (solution){
      history.push("/schedule", {solutionId: solution.id});
    }
  }

  const convertValue = (paramValue) => {
    let retString = "";
    if(!isNaN(paramValue)){
      retString = paramValue + ":00";
      return retString;
    } 
    let paramParsed = SafeParseJSON(paramValue);
    if (Array.isArray(paramParsed)){
      retString = paramParsed.join();
      return retString
    }

    return "";
  }

  const onSolutionDelete = async (solution) => {
    if (solution){
      let result = await Api.deleteSolution(solution.id)
      if (result){
        let newOpt = await Api.getOptimizationRequestById(opt.id);
        if (newOpt){
          setOpt(newOpt);
        }
      }
    }
  }

  const onFullDelete = async () => {
    setOpen(false);
    let success = await Api.deleteFullOptimization(opt.id);
    if (success){
      history.goBack();
    }
  }


  return (
    <Container>
    <Grid container justifyContent={"center"} spacing={1}>
      <Grid item xs={10}>
        <Typography variant="h5">
          {opt ? `${opt.name} Details` : <Skeleton />}
        </Typography>
        <Typography variant="subtitle1">
          {opt ? `Ran: ${ReadableDateTime(opt.dateRequested)}` : <Skeleton />}
        </Typography>
      </Grid>
      <Grid item xs={2} sx={{textAlign: "right"}}>
        {checkIfUserHasRole(UserUtils.RoleObjects.orgAdmin.name) &&
          <IconButton edge="end" onClick={() => setOpen(true)}>
            <DeleteIcon/>
          </IconButton>
        }
      </Grid>
      {/* <Grid item xs={12}>
        <Typography variant="subtitle1">
          {opt ? `Ran: ${ReadableDateTime(opt.DateRequested)} Details` : <Skeleton />}
        </Typography>
      </Grid> */}
      <Grid item xs={10}>
        <Accordion defaultExpanded={true}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon/>}
          >
            <Typography>
              Parameters
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{textAlign: "center"}}>
            <Table sx={{width: "60%", margin: "auto"}}>
              <TableBody>
                {opt.parameters && opt.parameters.map(param => 
                  <TableRow key={param.label}>
                    <TableCell>
                      {ParametersLabelToDisplayText[param.label] ?? param.label}:
                    </TableCell>
                    <TableCell>
                      {convertValue(param.value)}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>


            {/* <Grid container>
              {optimization.parameters && optimization.parameters.map(param => 
                <Grid item xs={6} key={param.id}>
                  <Typography>
                    {ParametersLabelToDisplayText[param.label]}: {convertValue(param.value)}
                  </Typography>


                </Grid>    
                )}

            </Grid> */}
            </AccordionDetails>
        </Accordion>

      </Grid>

      <Grid item xs={10}>
        <SolutionList solutions={opt.solutions} onItemClick={onItemClick} 
          onDelete={checkIfUserHasRole(UserUtils.RoleObjects.orgAdmin.name) ? onSolutionDelete : false}
        />
      </Grid>
      <ConfirmDialog 
          titleText="Delete this Optimization Request?" 
          open={open}
          handleClose={() => setOpen(false)}
          handleCancel={() => {
            setOpen(false);
          }}
          handleConfirm={onFullDelete}
        >
          Are you sure you'd like to delete optimization request {opt ? `'${opt.name}'` : ""}?
          This will additionally delete all solutions that are part of this Optimization Request. <br/>
          <b>This action cannot be undone.</b>
        </ConfirmDialog>


    </Grid>
    </Container>
  )
}